"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DownloadLinkBox = _interopRequireDefault(require("../DownloadLinkBox/DownloadLinkBox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VideosResult = _ref => {
  let {
    videos,
    lang,
    translate
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "videos sia-padding-04-bottom sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-03  sia-margin-03-bottom"
  }, translate('cms.search.videos')), /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: videos,
    lang: lang
  }));
};
var _default = exports.default = VideosResult;